// const getDefaultState = () => {
//     return {
//         sekolahData: [],
//         sekolahnya: [],
//         errors: []
//     }
//   }

// const state = getDefaultState()

export default {
    sekolahData: [],
    sekolahnya: [],
    errors: [],
    titikSolo: []
}